export default __webpack_public_path__ + "37bcbd8742e5d62d73f5a80d857ae9fe.svg";